import React, { useState, useEffect } from "react";
import api from "../../../../Axios/api";
import MaterialTable from "material-table";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import EditIcon from "@material-ui/icons/Edit";
import {
  Select,
  MenuItem,
  Grid,
  Paper,
  Modal,
  TextField,
  Container,
  Typography,
  Button,
} from "@material-ui/core";
import { useUserContext } from "../../../../context/UserContext";

import Pal from "../../../../themes/palette";
import useStyles from "./styles";

export default function ViewSellers() {
  const classes = useStyles();
  const { store } = useUserContext();
  const token = store.data.token;

  /////////////// Snackbar///////////////////////////////////////////////////////////////////
  const [snackBarstate, setSnackBar] = useState({
    open: false,
    vertical: "top",
    horizontal: "right",
    type: "success",
    message: "",
  });
  const { vertical, horizontal, open } = snackBarstate;
  const handleCloseSnackBar = () => {
    setSnackBar({ ...snackBarstate, open: false });
  };

  const handerChangeStatus = (id) => async (e) => {
    let newStatus = e.target.value;

    const newOrderDetails = details.map((order) =>
      order._id === id ? { ...order, status: newStatus } : order
    );

    await api
      .patch(
        `/superAdmin/seller/account/${id}`,
        { status: newStatus },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(() => {
        setSnackBar({
          ...snackBarstate,
          type: "success",
          message: "SUCCESS: Status has been Changed!",
          open: true,
        });
        setDetails(newOrderDetails);
      })
      .catch((error) => {
        setSnackBar({
          ...snackBarstate,
          type: "error",
          message: "ERROR: Something went Wrong!",
          open: true,
        });
      });
  };

  const checkStatusColor = (checkStatusColor) => {
    let color = "";
    switch (checkStatusColor) {
      case "Pending":
        color = "#ffb302";
        break;
      case "Active":
        color = "#5AA700";
        break;
      case "Blocked":
        color = "#ff3838";
        break;
      case "Deactivate":
        color = "#2E6FD9";
        break;
      default:
        color = "rgba(230, 126, 34, 0.7)";
    }

    return color;
  };
  ///////////////Snack Bar End ///////////////////////////////////////////////////////////////////

  const [details, setDetails] = useState();

  const columns = [
    {
      title: "ID",
      field: "tableData.id",
      render: ({ tableData }) => <div>{tableData.id + 1}</div>,
      hidden: false,
      export: false,
    },
    { title: "Name", field: "name" },
    { title: "Email", field: "email" },
    { title: "CNIC", field: "CNIC" },
    { title: "Contact", field: "phoneNumber" },

    { title: "Address", field: "address" },
    {
      title: "Status",
      field: "status",
      align: "center",
      render: ({ status }) => (
        <div
          style={{
            height: 30,
            width: 100,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: checkStatusColor(status),
            color: "white",
            borderRadius: 4,
          }}
        >
          {status}
        </div>
      ),
    },
    {
      field: "Actions",
      title: "Actions",
      align: "center",
      render: (rowData) => (
        <div>
          <Select
            id="status"
            style={{ marginTop: 8 }}
            defaultValue={"DEFAULT"}
            onChange={handerChangeStatus(rowData._id)}
          >
            <MenuItem value="DEFAULT" disabled>
              Status
            </MenuItem>
            <MenuItem value="Active">Active</MenuItem>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Blocked">Blocked</MenuItem>
            <MenuItem value="Deactivate">Deactivate</MenuItem>
          </Select>
        </div>
      ),
      export: false,
    },
  ];

  // category list retrive from DB
  const [IFerrors, setIFerrors] = useState({
    nameError: "",
    cnicError: "",
    emailError: "",
    phoneNumberError: "",
    passwordError: "",
    cityError: "",
    addressError: "",
    sellerNameError: "",
  });
  const [sellerId, setSellerId] = useState("");
  const [sellerDetails, setSellerDetails] = useState({
    name: "",
    CNIC: "",
    email: "",
    phoneNumber: "",
    city: "",
    address: "",
  });
  const handleSellerDetails = (input) => (e) => {
    setSellerDetails({ ...sellerDetails, [input]: e.target.value });
  };

  const editSellerHandler = (e) => {
    e.preventDefault();
    const { name, email, city, address, CNIC, phoneNumber } = sellerDetails;
    api
      .patch(
        `/superAdmin/seller/account/${sellerId}`,
        { name, email, city, address, CNIC, phoneNumber },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {
        try {
          const newDetails = details.map((prod) =>
            prod._id === sellerDetails._id ? sellerDetails : prod
          );
          setDetails(newDetails);
          handleClose();
          setSnackBar({
            ...snackBarstate,
            type: "success",
            message: "SUCCESS: Seller has been Updated!",
            open: true,
          });
        } catch (error) {}
      })
      .catch((error) => {
        handleClose();
        setSnackBar({
          ...snackBarstate,
          message: "ERROR: Something is not working properly!",
          type: "error",
          open: true,
        });
      });
  };

  // Edit Product Modal Settings here
  const [modalOpen, setModelOpen] = useState(false);
  const handleOpen = () => {
    setModelOpen(true);
  };
  const handleClose = () => {
    setModelOpen(false);
  };

  const retrivingAllSellers = async () => {
    await api
      .get("/superAdmin/sellers", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        console.log(res.data.data);
        setDetails(res.data.data.Sellers);
      })
      .catch((error) =>
        console.log("ERROR: " + JSON.stringify(error.response.data.error))
      );
  };

  useEffect(() => {
    // Retriving List of Products from API
    retrivingAllSellers();
  }, []);

  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} sm={12} md={12} component={Paper}>
        <MaterialTable
          style={{ width: "100%" }}
          title="Sellers Of Digi-Mart"
          data={details}
          columns={columns}
          actions={[
            (rowData) => ({
              icon: () => <EditIcon />,
              tooltip: "Edit",
              onClick: (event, rowData) => {
                setSellerDetails(rowData);
                // console.log(rowData._id);
                setSellerId(rowData._id);
                handleOpen();
              },
            }),
          ]}
          options={{
            actionsColumnIndex: -1,

            headerStyle: {
              backgroundColor: Pal.palette.primary.main,
              color: "#fff",
              whiteSpace: "nowrap",
            },
            exportButton: true,
            tableLayout: "auto",
          }}
        />
        <Snackbar
          open={open}
          anchorOrigin={{ vertical, horizontal }}
          autoHideDuration={3000}
          onClose={handleCloseSnackBar}
          key={vertical + horizontal}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={handleCloseSnackBar}
            severity={snackBarstate.type}
          >
            {snackBarstate.message}
          </MuiAlert>
        </Snackbar>
      </Grid>
      {/* /////////////////////Edit Seller/////////////////////////////////// */}
      <Modal
        open={modalOpen}
        onClose={handleClose}
        onBackdropClick={handleClose}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container component={Paper} maxWidth="md" style={{ padding: 20 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={12} align="center">
              <Typography variant="h5">Edit Seller Information</Typography>
            </Grid>
            <form className={classes.form} noValidate style={{ padding: 20 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    label="Name"
                    autoComplete="name"
                    fullWidth
                    value={sellerDetails.name}
                    onChange={handleSellerDetails("name")}
                    helperText={IFerrors.nameError}
                    error={IFerrors.nameError.length > 0 ? true : false}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    label="Cnic"
                    placeholder="XXXXX-XXXXXXX-X"
                    fullWidth
                    value={sellerDetails.CNIC}
                    onChange={handleSellerDetails("CNIC")}
                    inputProps={{ maxLength: 15 }}
                    helperText={IFerrors.cnicError}
                    error={IFerrors.cnicError.length > 0 ? true : false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    label="Email"
                    autoComplete="email"
                    fullWidth
                    value={sellerDetails.email}
                    onChange={handleSellerDetails("email")}
                    helperText={IFerrors.emailError}
                    error={IFerrors.emailError.length > 0 ? true : false}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    label="Phone Number"
                    fullWidth
                    placeholder="+923XXXXXXXXX"
                    inputProps={{ maxLength: 13 }}
                    value={sellerDetails.phoneNumber}
                    onChange={handleSellerDetails("phoneNumber")}
                    helperText={IFerrors.phoneNumberError}
                    error={IFerrors.phoneNumberError.length > 0 ? true : false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    label="City"
                    fullWidth
                    value={sellerDetails.city}
                    onChange={handleSellerDetails("city")}
                    helperText={IFerrors.cityError}
                    error={IFerrors.cityError.length > 0 ? true : false}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    label="Address"
                    fullWidth
                    value={sellerDetails.address}
                    onChange={handleSellerDetails("address")}
                    helperText={IFerrors.addressError}
                    error={IFerrors.addressError.length > 0 ? true : false}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12} md={12} align="right">
                <Button
                  variant="outlined"
                  color="primary"
                  style={{ marginRight: 10 }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={editSellerHandler}
                >
                  Save Changes
                </Button>
              </Grid>
            </form>
          </Grid>
        </Container>
      </Modal>

      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={3000}
        onClose={handleCloseSnackBar}
        key={vertical + horizontal}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackBar}
          severity={snackBarstate.type}
        >
          {snackBarstate.message}
        </MuiAlert>
      </Snackbar>
    </Grid>
  );
}
